// extracted by mini-css-extract-plugin
export var card = "FourCards-module--card--e-d+M";
export var cardDescription = "FourCards-module--cardDescription--8vLSE";
export var cardIcon = "FourCards-module--cardIcon--jq8hT";
export var cardTitle = "FourCards-module--cardTitle--9fQih";
export var cardsGrid = "FourCards-module--cardsGrid--vIZ3C";
export var cardsWrapper = "FourCards-module--cardsWrapper--5X+R6";
export var doctor = "FourCards-module--doctor--j3gbW";
export var iconImage = "FourCards-module--iconImage--Uep4b";